import { PageKey } from '../auth/page-access';

/** Route paths have no leading slash, as Angular's `Routes` want them. */
export const APP_PATHS = {
  login: 'login',
  noAccess: 'no-access',
} as const;

export const PAGE_ROUTES: Readonly<Record<PageKey, string>> = {
  'order-entry': 'order-entry',
  'edit-profile': 'profile',
  'create-invoice': 'create-invoice',
  'sales-dashboard': 'sales-dashboard',
  'view-invoice-sales': 'view-invoice-sales',
  'discount-page': 'discount-codes',
  codes: 'codes',
  'users-discount-code': 'discount-code-users/:code',
  'request-code': 'group-enrollment-ids',
  'users-enrollment': 'users-enrollment',
  affiliates: 'affiliates',
  'edit-affiliate': 'edit-affiliate/:id',
  'student-lookup': 'student-lookup',
  corporates: 'corporates',
  'add-corporate-account': 'corporate-account/:corpId',
  'corp-account-sites': 'corp-account-sites',
  'corporate-sites': 'corporate-sites',
  'widget-details': 'widget-designer/:siteId',
  'view-invoice-corporate': 'view-invoice-corporate',
  archive: 'archive',
};

/** Reserved for the legacy sign-in and enrollment links; not routed yet, so no page may use them. */
export const RESERVED_LEGACY_PATHS = {
  signIn: 'login.aspx',
  usersEnrollmentAlias: 'Sales/UsersEnrollment.aspx',
} as const;

/** Where a rep lands after sign-in when no page was asked for. */
export const HOME_PAGE: PageKey = 'order-entry';
